import * as z from "zod";

import { PartnerSummarySchema } from "../shared/partner";

export const getMe = {
  name: "getMe" as const,
  input: z.object({}),
  output: z.object({ partner: PartnerSummarySchema }),
};
